import { useEffect, useRef, useState } from 'react';
import NoData from '@/widget/NoData';
import { IAddressHistory } from '@/request/smartMoney/smartMoney.response.interface';
import ActivityHead from './components/ActivityHead';
import ActivityLoading from './components/ActivityLoading';
import ActivityRow from './components/ActivityRow';
import { useDynamicHeight } from '@/hooks/base/useDynamicHeight';
import { useVirtualizer } from '@tanstack/react-virtual';
import { TradeType } from '../../hooks/useActivityList';

interface IProps {
  loading: boolean;
  activityList: IAddressHistory[];
  tradeType: TradeType;
  setTradeType: (tradeType: TradeType) => void;
}

export default (props: IProps) => {
  const { tradeType, loading, activityList, setTradeType } = props;
  const height = useDynamicHeight({ customHeight: 32 });

  const [renderList, setRenderList] = useState<IAddressHistory[]>([]);

  useEffect(() => {
    if (tradeType == 'all') {
      setRenderList(activityList);
    } else {
      const list = activityList.filter((item) => item.type == tradeType);
      setRenderList(list);
    }
  }, [tradeType, activityList]);
  const parentRef = useRef<HTMLDivElement>(null);

  const rowVirtualizer = useVirtualizer({
    count: renderList.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 72,
    overscan: 5,
  });
  return (
    <div>
      <ActivityHead tradeType={tradeType} setTradeType={setTradeType} />
      {loading ? (
        <ActivityLoading />
      ) : renderList.length > 0 ? (
        <div
          ref={parentRef}
          style={{
            height: height + 'px',
            overflow: 'auto',
          }}
        >
          <div
            style={{
              height: `${rowVirtualizer.getTotalSize()}px`,
              width: '100%',
              position: 'relative',
            }}
          >
            {rowVirtualizer.getVirtualItems().map((virtualRow) => (
              <div
                key={virtualRow.index}
                style={{
                  position: 'absolute',
                  width: '100%',
                  transform: `translateY(${virtualRow.start}px)`,
                }}
              >
                <ActivityRow activity={renderList[virtualRow.index]} />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <NoData />
      )}
    </div>
  );
};
